import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/content';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 高清免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-3">{movie.description}</p>
        </div>
        {movie.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            新
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            热播
          </span>
        )}
        <div className="absolute bottom-2 left-2 bg-black/60 text-accent-400 text-xs px-1.5 py-0.5 rounded">
          {movie.rating}
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400" />
          <span>{movie.subCategory}</span>
          {movie.category === 'tv' && (
            <>
              <span className="w-1 h-1 rounded-full bg-foreground-400" />
              <span>{movie.episodes}</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}